// @flow

import { useUserInputValue } from '@tectonics/prs/user-input-values';

const EWALLETS_REQUIRING_DOCUMENT = ['qrcode-bind'];

export function useArgentineEwalletDocumentForceShow(): boolean {
  const [selectedPaymentMethod] = useUserInputValue('selectedPaymentMethod');
  const [selectedEWallet] = useUserInputValue('selectedEWallet');

  if (selectedPaymentMethod !== 'ewallet') {
    return false;
  }

  return EWALLETS_REQUIRING_DOCUMENT.includes(selectedEWallet);
}
